/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumMailIndex.vue?vue&type=template&id=74894051&scoped=true"
import script from "./ForumMailIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumMailIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumMailIndex.vue?vue&type=style&index=0&id=74894051&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74894051",
  null
  
)

export default component.exports